import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import { LanguageColumn as LanguageColumnConfig } from '@bingads-webui-campaign/ad-groups-data';
import { LanguageInlineEditView } from './inline-editable/language-view';
import { InlineEditableSave } from './inline-editable/save';


export class LanguageColumn extends CampaignuiBaseColumn {
  constructor({
    i18n, scope, view, isForVNext,
  }) {
    const title = i18n.getString('ColumnName_Language');
    const appConfig = globalContext.require('component/config/index');
    const permissions = appConfig.get('Permissions');
    const isDSAMixedModeCampaignEnabled = _.result(permissions, 'IsDSAMixedModeCampaignEnabled', false);

    super({
      ...LanguageColumnConfig,
      title,
      editable: true,
      type: 'string',
      enableEdit: item => this.shouldEnableInlineEdit(item, isDSAMixedModeCampaignEnabled),
      helpId: 'pop_BA_Settings_Language',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.scope = scope;
    this.i18n = i18n;
    this.view = view;
    this.isForVNext = isForVNext;
  }

  shouldEnableInlineEdit(item, isDSAMixedModeCampaignEnabled) {
    const adGroupType = item.AdGroupType;

    return item.Campaign && item.Campaign.CampaignType &&
     // currently only default type is inline editable
     item.Campaign.CampaignType === 'Default' &&
     // For users enabled mixed mode campaign pilot,
     // we should check whether current ad group is dynamic ad group
     ((isDSAMixedModeCampaignEnabled && adGroupType !== 'SearchDynamic') || !isDSAMixedModeCampaignEnabled);
  }

  pickProperty(item) {
    if (item.$total) {
      return ' ';
    }

    return item.Language ?
      this.i18n.getString(`Language_${item.Language}`) :
      this.i18n.getString('Language_Inherit');
  }

  onPrompt({ position, item, newPosition }) {
    const languageEditorView = new LanguageInlineEditView({
      selectedLanguage: item.Language,
      i18n: this.i18n,
      campaignHasLanguage:
        item.Campaign && item.Campaign.Languages && item.Campaign.Languages.length > 0,
    });

    languageEditorView.on('save', ({ selectedLanguage }) => {
      const updated = _.extendOwn({}, item, { Language: selectedLanguage });

      return InlineEditableSave({
        view: this.view,
        i18n: this.i18n,
        fieldName: 'Language',
        updated,
        editorView: languageEditorView,
        editorViewCallbackAfterUpdate: () => {
          languageEditorView.trigger('close');
        },
      });
    });
    const groupClass = `grid-group-${_.result(this.config, 'group', 'other')}`;
    const editorView = new GridCustomizedPopupEditor({
      editorView: languageEditorView.render(),
      cellPosition: this.isForVNext ? newPosition : position,
      renderBelow: false,
      className: `adgroup-grid-inline-edit-popup grid-popupeditor ${groupClass}`,
      parentContainerSelector: this.isForVNext ? '.grid-and-disclaim-container' : null,
    });

    return editorView.render();
  }
}
